export default __webpack_public_path__ + "static/media/IMG-20241005-WA0052.33481e05.jpg";